import * as React from "react";
import {ISvgIconProps, SvgIcon} from '../../../../../basic-ui-components/icon/svg-icon/svg.icon';

export class VipIcon extends React.Component<ISvgIconProps> {
    render() {
        return (
            <SvgIcon {...this.props}>
                <g fill="currentColor">
                    <path d="M7.63,14.684l1.953-5.648h1.136l-2.535,6.878H6.683L4.148,9.036h1.139l1.965,5.648
                        l0.189,0.545L7.63,14.684z M19.931,11.087L19.931,11.087v0.004c0.001,0.348-0.086,0.691-0.253,0.997
                        c-0.18,0.319-0.453,0.578-0.782,0.741c-0.435,0.209-0.914,0.31-1.397,0.293v0h-0.007h-1.226h-0.2v0.2v2.593h-1.067V9.036h2.492v0
                        l0.006,0c0.467-0.013,0.932,0.08,1.357,0.274c0.336,0.155,0.617,0.407,0.807,0.722C19.844,10.353,19.938,10.717,19.931,11.087z
                        M16.265,12.341h1.156c0.373,0.028,0.743-0.087,1.034-0.321l0.009-0.007l0.008-0.008c0.121-0.122,0.214-0.267,0.275-0.427
                        c0.06-0.158,0.086-0.327,0.077-0.496c-0.001-0.389-0.112-0.716-0.366-0.941c-0.25-0.223-0.605-0.317-1.029-0.317h-1.164h-0.2v0.2
                        v2.117v0.2H16.265z M13.153,9.036v6.878h-1.067V9.036H13.153z"/>
                    <path d="M22,4.893c0,0.216-0.175,0.392-0.392,0.392H2.392C2.175,5.284,2,5.109,2,4.893c0-0.216,0.175-0.392,0.392-0.392h19.216
                        C21.825,4.501,22,4.676,22,4.893z"/>
                    <path d="M22,19.107c0,0.216-0.175,0.392-0.392,0.392H2.392C2.175,19.499,2,19.324,2,19.107c0-0.216,0.175-0.392,0.392-0.392h19.216
                        C21.825,18.716,22,18.891,22,19.107z"/>
                </g>
            </SvgIcon>
        );
    }
}
